import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as C from '../store/constants';

import WellCome from './screens/WellCome';
import GameArea from './screens/GameArea';
import GameEnd from './screens/GameEnd';
import Answer from './screens/Answer';

import { GAGameEnd, GAGameWin } from "../analytics.js";

export default
@connect(state => {
  return {
    route: state.game.route,
    level: state.game.level,
  }
})
class Router extends Component {
  render() {
      switch (this.props.route) {
        case C.ROUTE_START:
          return <WellCome />;
        case C.ROUTE_GAME:
          return <GameArea />;
        case C.ROUTE_ANSWER:
          return <Answer />;
        case C.ROUTE_LAST_ANSWER:
          return <Answer last={true} />;
        case C.ROUTE_END:
          GAGameEnd(this.props.level);
          return <GameEnd />;
        case C.ROUTE_WIN:
          GAGameWin();
          return <GameEnd win={true}/>;
        default:
          return <WellCome />;
      };
  }
}
